import React from 'react';
import '../Estilos/Componentes.css';
export default function SubTopicoTexto(props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        width: '90%',
        height: '55px',
      }}
    >
      <h4 id="FonteSubTopico">{props.titulo}</h4>
      <div style={{ height: 3, backgroundColor: '#E9ECF0', width: 52 }}></div>
    </div>
  );
}
